export const LOGIN_Feature = import.meta.env.VITE_FEATURES_LOGIN_REGISTRY
export const PAYMENTS_PORTAL_Feature = import.meta.env.VITE_FEATURES_PAYMENTS_PORTAL
export const DOCUMENTS_Feature = import.meta.env.VITE_FEATURES_DOCUMENTS
export const PAYMENTS_PANEL_Feature = import.meta.env.VITE_FEATURES_PAYMENTS_PANEL
export const SEARCH_Feature = import.meta.env.VITE_FEATURES_SEARCH
export const MEDIA_Feature = import.meta.env.VITE_FEATURES_MEDIA
